// extracted by mini-css-extract-plugin
module.exports = {"uploadList":"DocumentUpload_uploadList__2k3lQ","uploadListItem":"DocumentUpload_uploadListItem__22aAd","listIcon":"DocumentUpload_listIcon__2ktmk"};